
import { driver } from "driver.js";
import "driver.js/dist/driver.css";

// Wij configureren hier de 'driver' (de tour engine) met onze styling
export const startDashboardTour = () => {
    if (navigator.webdriver) return; // Disable tours in E2E tests

    const driverObj = driver({
        showProgress: true,
        animate: true,
        allowClose: true,
        doneBtnText: "Klaar! 🚀",
        nextBtnText: "Volgende →",
        prevBtnText: "← Vorige",
        progressText: "{{current}} van {{total}}",
        steps: [
            {
                element: '#tour-welcome',
                popover: {
                    title: '👋 Welkom bij ProPoule',
                    description: 'Gefeliciteerd met je nieuwe account! Ik neem je in vogelvlucht mee door de applicatie.',
                    side: "left",
                    align: 'start'
                }
            },
            {
                element: '#tour-create-btn',
                popover: {
                    title: '🚀 Start hier',
                    description: 'Dit is de belangrijkste knop. Klik hier om een nieuw toernooi aan te maken.',
                    side: "bottom",
                    align: 'start'
                }
            },
            {
                element: '#tour-stats',
                popover: {
                    title: '📊 Statistieken',
                    description: 'Hier zie je in één oogopslag je actieve toernooien en totaal aantal teams.',
                    side: "bottom",
                    align: 'start'
                }
            },
            {
                element: '#tour-sidebar-help',
                popover: {
                    title: '🤖 Hulp & AI',
                    description: 'Inclusief AI Hulp Assistent en Sponsor Tools.',
                    side: "right",
                    align: 'center'
                }
            },
            {
                element: '#tour-upgrade',
                popover: {
                    title: '⭐ Premium Functies',
                    description: 'Upgrade hier voor onbeperkte mogelijkheden en TV modus.',
                    side: "right",
                    align: 'center'
                }
            }
        ],
        // Belangrijk: Markeer direct als gezien zodra de tour start.
        // Dit voorkomt dat bij een refresh (zonder 'klaar' te klikken) de tour opnieuw verschijnt.
        onHighlightStarted: () => {
            localStorage.setItem('propoule_tour_seen', 'true');
        },
        onDestroy: () => {
            localStorage.setItem('propoule_tour_seen', 'true');
        }
    });

    driverObj.drive();
};

export const startWizardTour = () => {
    if (navigator.webdriver) return; // Disable tours in E2E tests

    // Check of we deze wizard tour al gezien hebben
    if (localStorage.getItem('propoule_wizard_seen')) return;

    const driverObj = driver({
        showProgress: true,
        animate: true,
        allowClose: true,
        doneBtnText: "Begrepen 👍",
        nextBtnText: "Volgende",
        prevBtnText: "Terug",
        steps: [
            {
                element: '#wizard-name',
                popover: {
                    title: '1. Toernooi Naam',
                    description: 'Geef je toernooi een pakkende naam. Bijvoorbeeld "Winter Cup 2025" of "Bedrijfstoernooi".',
                    side: "top",
                    align: 'start'
                }
            },
            {
                element: '#wizard-sport',
                popover: {
                    title: '2. Sport Type',
                    description: 'Kies hoe de scores werken. <br>⚽ <b>Doelpunten</b>: Voor voetbal, hockey, handbal (bv. 3-1). <br>🎾 <b>Sets</b>: Voor tennis, padel, volleybal (bv. 6-4, 6-2).',
                    side: "top",
                    align: 'center'
                }
            },
            {
                element: '#wizard-type',
                popover: {
                    title: '3. Toernooivorm',
                    description: 'Kies de structuur:<br>• <b>Klassiek</b>: Poules gevolgd door knock-out finales.<br>• <b>Alleen Poules</b>: Gewoon een competitie.<br>• <b>Knock-out</b>: Direct afvallen.',
                    side: "top",
                    align: 'center'
                }
            },
            {
                element: '#wizard-submit',
                popover: {
                    title: '4. Aanmaken',
                    description: 'Klik hier om alles te bevestigen. Wij zetten de structuur voor je klaar!',
                    side: "top",
                    align: 'end'
                }
            }
        ],
        onHighlightStarted: () => {
            localStorage.setItem('propoule_wizard_seen', 'true');
        },
        onDestroy: () => {
            localStorage.setItem('propoule_wizard_seen', 'true');
        }
    });

    // Kleine vertraging om zeker te zijn dat de modal gerenderd is
    setTimeout(() => {
        driverObj.drive();
    }, 500);
};

export const resetTours = () => {
    localStorage.removeItem('propoule_tour_seen');
    localStorage.removeItem('propoule_wizard_seen');
    window.location.reload();
};
